import React, { useCallback, useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Form from 'components/form/Form'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import snackbarActions from 'store/modules/snackbar'
import bookActions from 'store/modules/booking'
import routerSelectors from 'store/selectors/router'
import bookSelectors from 'store/selectors/booking'
import projectSelectors from 'store/selectors/project'
import adminSelectors from 'store/selectors/admin'

import useReplaceLinkTarget from 'components/hooks/useReplaceLinkTarget'

const SCHEMA = [{
  id: 'embed_widget',
  title: 'Embed Settings',
  helperText: 'Control what displays on your embedded widget',
  component: 'embedWidget',
  autoEnabled: true,
}]

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(4),
  },
  marginTop: {
    marginTop: theme.spacing(2),
  },
  buttons: {
    marginTop: theme.spacing(4),
  },
  copyButton: {
    margin: theme.spacing(2),
  },
  actionButton: {
    marginLeft: theme.spacing(1),
  },
  configField: {
    width: '100%',
  },
  pre: {
    background: '#000',
    color: '#fff',
    fontFamily: 'Courier',
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  example: {

  },
  exampleInner: {
    border: '1px solid #ccc',
    padding: theme.spacing(4),
  },
}))

const BookingFormWelcomeEmbedHTML = ({
  html,
}) => {
  const rootRef = useReplaceLinkTarget({
    disable: true,
    html,
  })

  return (
    <div ref={ rootRef }>
      <div dangerouslySetInnerHTML={{__html: html}}>

      </div>
    </div>
  )
}

const BookingFormEmbedSettings = ({

}) => {

  const classes = useStyles()
  const dispatch = useDispatch()
  const [ embedScript, setEmbedScript ] = useState(null)
  const embedHTML = useSelector(bookSelectors.embedHTML)

  const project = useSelector(projectSelectors.currentProject)
  const {
    id,
  } = useSelector(routerSelectors.params)
  const config = useSelector(adminSelectors.config)

  const onSubmit = useCallback(async values => {
    const {
      embed_widget: {
        days,
        slotsPerDay,
      }
    } = values
    dispatch(bookActions.loadEmbedHTML({
      project: project.id,
      bookingform: id,
      days,
      slotsPerDay,
    }))
    setEmbedScript(`
<script type="application/javascript" src="${config.appurl}/api/v1/booking/embedJS/${project.id}/${id}?days=${days}&slotsPerDay=${slotsPerDay}"></script>
`)

  }, [
    project,
    id,
  ])

  const onCopy = useCallback(() => {
    dispatch(snackbarActions.setSuccess(`copied to clipboard`))
  }, [])

  return (
    <div className={ classes.root }>
      <Grid container spacing={ 4 }>
        <Grid item xs={ 12 } sm={ 6 }>
          <Paper className={ classes.paper }>
            <Form
              schema={ SCHEMA }
              initialValues={ {} }
              onSubmit={ onSubmit }
            >
              {
                ({
                  onSubmit,
                }) => {
                  return (
                    <div className={ classes.buttons }>
                      <Button
                        className={ classes.actionButton }
                        variant="contained"
                        color="primary"
                        onClick={ onSubmit }
                      >
                        Get Embed Code
                      </Button>
                    </div>
                  )
                }
              }
            </Form>
          </Paper>
        </Grid>
        {
          embedScript && (
            <Grid item xs={ 12 } sm={ 6 }>
              <Paper className={ classes.paper }>
                <Typography variant="h6" gutterBottom>Embed Code</Typography>
                <Typography variant="body1" gutterBottom>
                  You can paste this HTML on any website to display a live preview of upcoming dates with links to book.
                </Typography>
                <pre className={ classes.pre }>{ embedScript }</pre>
                <CopyToClipboard
                  text={ embedScript }
                  onCopy={ onCopy }
                >
                  <Button
                    type="button"
                    size="small"
                    variant="contained"
                    className={ classes.copyButton }
                  >
                    Copy to clipboard
                  </Button>
                </CopyToClipboard>
                {
                  embedHTML && (
                    <div className={ classes.example }>
                      <Typography variant="h6" gutterBottom>Example</Typography>
                      <div className={ classes.exampleInner }>
                        <BookingFormWelcomeEmbedHTML
                          html={ embedHTML }
                        />
                      </div>
                    </div>
                  )
                }
              </Paper>
            </Grid>
          )
        }
      </Grid>
    </div>
  )
}

export default BookingFormEmbedSettings